'use strict';
var commonBoutique = require('./_commonBoutique');
var base = require('./base');
var urlUtil = require('./../common/urlUtil');

function countrySelect(Url, countryCode, displayValue) {
    var queryParams = urlUtil.getQueryParams();
    var query = base.createQueryParam(queryParams);
    $.spinner().start();
    $.ajax({
        url: Url,
        method: 'GET',
        data: 'countryCode=' + countryCode + query,
        success: function (data) {
            history.replaceState(null, null, urlUtil.replaceOrAddQueryParam(document.location.href, 'countryCode', countryCode));
            base.updateboutiques(data.filterListHtml, displayValue);
            base.activeFeFilter();
            $.spinner().stop();
            commonBoutique.createMap(data.filterList, false, countryCode);
        }
    });
}

module.exports = {

    handleAccessibility: function(){
        $(document).on('click', '.js-accessible-aria-checked', function() {
            var button = $(this);
            var ariaChecked = button.attr('aria-checked') === 'true';
            button.attr('aria-checked', ariaChecked ? 'false' : 'true');
        });
    },

    telephonLink: function() {
        $(document).on('click', '.js-select-boutiques .js-telephone-boutique', function(e) {
            var boutiqueID = $(this).attr('data-id');
            var boutiqueName = $(this).attr('data-name');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'boutique locator service',
                eventAction: 'detail',
                eventLabel: 'call',
                boutiqueName: boutiqueName + '–' + boutiqueID
            });
            e.stopPropagation();
        });
    },

    bookAppointment: function() {
        $(document).on('click', '.js-book-appointment-list', function(e) {
            var boutiqueID = $(this).attr('data-id');
            var boutiqueName = $(this).attr('data-name');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'exclusive-service',
                eventAction: 'store-locator-map',
                eventLabel: 'boutique-appointment',
                boutiqueName: boutiqueName + '–' + boutiqueID
            });
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'boutique locator service',
                eventAction: 'map',
                eventLabel: 'appointment',
                boutiqueName: boutiqueName + '–' + boutiqueID
            });

            e.stopPropagation();
        });
    },

    mobileButton: function () {
        $(document).ready(function () {
            if ($('body').hasClass('cc-mobile')) {
                $('.cc-boutiques-opened-desktop-tab').css('visibility', 'hidden');
                $('.cc-boutiques-opened-mobile').css('visibility', 'visible');
                $('.cc-boutiques-opened-mobile').css('display', 'block');
            } else {
                $('.cc-boutiques-opened-mobile').css('visibility', 'hidden');
                $('.cc-boutiques-opened-mobile').css('display', 'none');
            }
        });
    },

    selectContry: function () {
        $(document).on('change', '#js-boutiques-selectCountry', function () {
            var url = $('.cc-content-select').data('findboutiques');
            $('#js-boutiques-selectCountry').val(this.value);
            countrySelect(url, this.value, $('#js-boutiques-selectCountry option:selected').text());
            base.cleanFilter();
        });
    },

    currentContry: function () {
        $(document).ready(function () {
            if (document.location.href.indexOf('countryCode=') !== -1) {
                var position = document.location.href.indexOf('countryCode=');
                var countryUrl = document.location.href.substring(position).split('countryCode=')[1].split('&')[0];
                var currentCountry = countryUrl;
            } else {
                var currentCountry = currentCountryCode;
            }
            var displayValue = $("#js-boutiques-selectCountry option[value='" + currentCountry).text();
            $('.filter-option-inner-inner').html(displayValue);
            var url = $('.cc-content-select').data('findboutiques');
            $('#js-boutiques-selectCountry').val(currentCountry);
            countrySelect(url, currentCountry, displayValue);
        });
    },
    // in custom dropdow for select country
    setplaceholder: function() {
        $(document).ready(function () {
            var placeholder = $('.cc-boutiques-locator-find').data('placeholder');
            $('.bs-searchbox input').attr('placeholder', placeholder);
        });
    },

    checkBoutiquefilter: function () {
        $(document).on('click', '.cc-service-filter .cc-service-items', function () {
            var active = $(this).hasClass('cc-active-iteams');
            if (active) {
                $(this).removeClass('cc-active-iteams').find('button').attr('aria-selected', 'false');
            } else {
                $(this).addClass('cc-active-iteams').find('button').attr('aria-selected', 'true');
            }
        });
    },

    selectBoutiques: function () {
        $(document).on('click', '.js-active-search', function () {
            var boutiqueID = this.dataset.boutiqueid;
            $('.cc-single-boutiques-result').removeClass('cc-active-live-search');
            $('.js-boutique-' + boutiqueID).addClass('cc-active-live-search');
        });
    },

    filterBoutique: function() {
        $(document).on('click', '.js-filter-event .cc-service-items', function () {
            var url = $('.js-boutique-filter-url').data('filterboutique');
            var returned = $('#js-boutique-filter-returned').hasClass('cc-active-iteams');
            var repair = $('#js-boutique-filter-repair').hasClass('cc-active-iteams');
            var sartoria = $('#js-boutique-filter-sartoria').hasClass('cc-active-iteams');
            var pikup = $('#js-boutique-filter-pickup').hasClass('cc-active-iteams');
            var fragrances = $('#js-boutique-filter-fragrances').hasClass('cc-active-iteams');
            var countryCode = $('#js-boutiques-selectCountry').val();
            var countryDisplayValue = $('.cc-findBoutique-select .filter-option-inner-inner').text();
            $.ajax({
                url: url,
                method: 'GET',
                data: {
                    countryCode: countryCode,
                    returned: returned,
                    repair: repair,
                    sartoria: sartoria,
                    pickup: pikup,
                    fragrances: fragrances
                },
                success: function (data) {
                    base.updateboutiques(data.boutiquesFilteredHtml, countryDisplayValue);
                    base.updateQueryParam();
                    commonBoutique.createMap(data.boutiquesFiltered, false, countryCode);
                }
            });
        });
    }
};
